import { setLocalStorageItem, getLocalStorageItem } from '@/utils';
import { useAuth, IUser } from '@/hooks';
import JWT from 'jwt-decode';

const TOKEN_KEY = 'authToken';
const REDIRECT_PAGE_URL = 'jarvisRedirectPage'; // in case the user needs to re-authenticate when landing on a non home page, this redirect page url will be used instead, this will provide better UX as the user can land back on where they first

export const getToken = () => getLocalStorageItem(TOKEN_KEY);

export const setToken = (token: string) => setLocalStorageItem(TOKEN_KEY, token);

export const saveToken = (token: string) => setToken(token);

export const hasToken = (): boolean => {
  if (getToken()) return true;

  return false;
};

export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

// the encoded token includes firstName, lastName, email, user_name, uid, exp etc.
export const parsedTokenInfo = (token: string): IUser => JWT(token);

export const hasTokenExpired = (token: string) =>
  new Date() > new Date(parsedTokenInfo(token).exp * 1000);

export const refreshToken = () => {
  const currentToken = getToken();
  if (hasTokenExpired(currentToken)) {
    window.location.href = process.env.VUE_APP_SIGN_IN_URL;
  } else {
    const { loginSuccess } = useAuth();
    loginSuccess(currentToken);
  }
};

export const setRedirectUrl = () => {
  const redirectUrl = window.location.hash.replace('#', '');
  setLocalStorageItem(REDIRECT_PAGE_URL, redirectUrl);
};

export const getRedirectUrl = (): string => getLocalStorageItem(REDIRECT_PAGE_URL);

export const getJWTFromURL = (): string | null => {
  if (window.location.href.split('access_token=').length === 1) {
    return null;
  } else {
    return window.location.href.split('access_token=')[1].split('&')[0];
  }
};

export const validateToken = () => {
  // here we first check if token coming from URL
  let token = getJWTFromURL() as string;
  // if token is in url (means it came from the new application)
  if (token) {
    saveToken(token);
    return true;

    // check if token is in local storage
  } else if (hasToken()) {
    token = getToken();

    // check if token in localstorage is expired
    if (hasTokenExpired(token)) {
      return false;
    } else {
      return true;
    }

    // no token in url or local storage
  } else {
    return false;
  }
};

export const checkToken = () => validateToken();
